// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"Filters__modalContainer___aKCrs","modalBody":"Filters__modalBody___2kFbY","title":"Filters__title___SoS0V","subtitle":"Filters__subtitle___3-sjn","dividerDouble":"Filters__dividerDouble___2IjkM","CTAContainer":"Filters__CTAContainer___3zOxZ","filtersContainer":"Filters__filtersContainer___Cksb1"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/invoices/components/Filters.scss
// module id = 1708
// module chunks = 0